define('Redbox_Faq/js/content-type/faq/appearance/default/widget',[
    'jquery',
    'accordion',
    'domReady!'
], function ($) {
    'use strict';

    return function (config, element) {
        var element = $(element);

        element.children("li").each(function (i) {
            $(this).find("[data-collapsible]").attr("data-role", "collapsible");
            $(this).find("[data-content]").attr("data-role", "content");
        });

        element.accordion({
            active: [], //optional - option from accordion
            collapsible: true
        });
    };
});

